import React from "react";
import { DogiCard } from "zina-dogi-react";
import { Formik, Form, Field } from "formik";
import CircleLoader from "react-spinners/CircleLoader";
import { Input, FormFeedback, UncontrolledTooltip } from "reactstrap";
import { Link } from "react-router-dom";
import { service } from "../redux";
import logo from "../../assets/imgs/nokia-official-logo.png";
import zina_logo from "../../assets/imgs/zina-india-logo-negativo.svg";
import fondo from "../../assets/imgs/fondo.png";

class ResetPasswordConfirm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            waiting_response: false,
            success: {},
            errors: {}
        };
    }

    onChange = (val, formik, field) => {
        this.setState({ errors: { ...this.state.errors, [field]: null } });
        formik.setFieldValue(field, val.target.value, false);
    };

    showErrors = field => {
        if (this.state.errors[field] && this.state.errors[field].length) {
            return this.state.errors[field].map(item => {
                return <FormFeedback>{item}</FormFeedback>;
            });
        }
    };

    onSubmit = (values, formik) => {
        this.setState({ waiting_response: true });
        this.setState({ errors: {} });
        this.setState({ success: {} });
        formik.setSubmitting(true);
        const data = {
            password1: values.password1,
            password2: values.password2,
            uid: this.props.match.params.uid,
            token: this.props.match.params.token
        };
        service
            .resetPasswordConfirm(data)
            .then(response => {
                formik.setSubmitting(false);
                this.setState({ success: response.data });
                this.setState({ waiting_response: false });
            })
            .catch(error => {
                formik.setSubmitting(false);
                if (error && error.response && error.response.data) {
                    console.log(error.response.data);
                    this.setState({ errors: error.response.data });
                }
                this.setState({ waiting_response: false });
            });
    };

    render() {
        const items = [{ id: 1, src: zina_logo }];
        return (
            <DogiCard logo={logo} items={items} fondo={fondo}>
                <Formik className="loginForm" enableReinitialize={true} onSubmit={this.onSubmit}>
                    {formik => (
                        <Form className="form">
                            <div className="titles">
                                <br />
                                <b>Reset password</b>
                                <br />
                                <p>
                                    Enter a new password.{" "}
                                    <span
                                        style={{ textDecoration: "underline", color: "blue" }}
                                        href="#"
                                        id="help-tooltip"
                                    >
                                        Help
                                    </span>
                                    .
                                </p>
                                <UncontrolledTooltip placement="right" target="help-tooltip" className="help-tooltip">
                                    <ul>
                                        <li>Your password can't be too similar to your other personal information.</li>
                                        <li>Your password must contain at least 8 characters.</li>
                                        <li>Your password can't be a commonly used password.</li>
                                        <li>Your password can't be entirely numeric.</li>
                                    </ul>
                                </UncontrolledTooltip>
                            </div>
                            {this.state.success.detail && (
                                <div className="titles text-success">
                                    <b>Success</b>
                                    <br />
                                    <span>{this.state.success.detail}</span>
                                    <br />
                                    <br />
                                </div>
                            )}
                            {this.state.errors.non_field_errors && this.state.errors.non_field_errors.length && (
                                <div className="titles text-danger">
                                    {this.state.errors.non_field_errors.map(item => {
                                        return (
                                            <span>
                                                {item}
                                                <br />
                                            </span>
                                        );
                                    })}
                                </div>
                            )}
                            {!this.state.success.detail && (
                                <div>
                                    <div className="fields">
                                        <div className="form-group">
                                            <Field
                                                value={formik.values.password1}
                                                className="form-control"
                                                placeholder="Password"
                                                name="password1"
                                                required={true}
                                                type="password"
                                                component={Input}
                                                invalid={!!this.state.errors.password1}
                                                onChange={val => this.onChange(val, formik, "password1")}
                                            />
                                            {this.showErrors("password1")}
                                        </div>
                                        <div className="form-group">
                                            <Field
                                                value={formik.values.password2}
                                                className="form-control"
                                                placeholder="Repeat password"
                                                name="password2"
                                                required={true}
                                                type="password"
                                                component={Input}
                                                invalid={!!this.state.errors.password2}
                                                onChange={val => this.onChange(val, formik, "password2")}
                                            />
                                            {this.showErrors("password2")}
                                        </div>
                                    </div>
                                    <div className="controls">
                                        <button
                                            type="submit"
                                            className="btn btn-success col"
                                            disabled={formik.isSubmitting}
                                        >
                                            Next
                                        </button>
                                        <CircleLoader loading={this.state.waiting_response} color={"#007bff"} />
                                    </div>
                                </div>
                            )}
                            <div className="row">
                                <div className="col-md-5">
                                    <Link to={`/login/`}>Go to login</Link>
                                </div>
                                <div className="col-md-7 text-right">
                                    <Link to={`/password-recovery/`}>Forgot password</Link>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </DogiCard>
        );
    }
}

export default ResetPasswordConfirm;
